"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var Heading_1 = __importDefault(require("shared/components/Heading"));
var AuthIntroSection_1 = __importDefault(require("../AuthIntroSection"));
var hooks_1 = require("../hooks");
var StyledGrid_1 = __importDefault(require("../styles/StyledGrid"));
var ResetPassForm_1 = __importDefault(require("./ResetPassForm"));
var ResetPasswordContent = function () {
    (0, hooks_1.useRedirectIfAuth)();
    return ((0, jsx_runtime_1.jsxs)(StyledGrid_1.default, __assign({ container: true, spacing: 4, justifyContent: "center" }, { children: [(0, jsx_runtime_1.jsx)(AuthIntroSection_1.default, { welcomeMsg: "Forgot your password?" }), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: 12, md: 4, container: true, alignItems: "center" }, { children: (0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ my: 4 }, { children: [(0, jsx_runtime_1.jsx)(Heading_1.default, __assign({ level: 3 }, { children: "Don\u2019t worry, we\u2019ll send you an email to set your password" })), (0, jsx_runtime_1.jsx)(ResetPassForm_1.default, {})] })) }))] })));
};
exports.default = ResetPasswordContent;
